import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import visionLogoImage from "../../assets/images/vision_logo.jpeg";

const useStyles = makeStyles(_ => ({
  image: {
    maxWidth: "100%",
    objectFit: "contain"
  }
}));

function Logo(props) {
  const classes = useStyles();
  const id = props.id || "";
  return (
    <img
      id={id}
      src={props.logo || visionLogoImage}
      alt="logo"
      className={classes.image}
    />
  );
}

export default Logo;

Logo.propTypes = {
  logo: PropTypes.string
};
